import { z } from "zod";

export const awardTagSchema = z.object({
  tagName: z.string().min(1, "Points Tag is required").max(100, "Tag name must be less than 100 characters")
});

export type AwardTagFormData = z.infer<typeof awardTagSchema>;
